export default __webpack_public_path__ + "static/media/ManDrawingOnBoard.1fa64784.png";